export const fonts = {
  primary: "'SaveurSans', sans-serif",
  secondary: '"HendersonSlab", sans-serif',
  globa:
    "'Poppins', 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
};
